import { AppError } from "config/errors";
import { LockTypeStrings } from "config/types";
import { fetchAccountCapabilities, fetchUnderwritingAvailability } from "gql/queries/account";
import { fetchEligibleForUnderwriting } from "gql/queries/eligibleForUnderwriting";
import { LOCK_ACCOUNT, UNLOCK_ACCOUNT } from "store/constants";
import { getActiveAccount } from "utils/account";

import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { first } from "lodash-es";

/* ------------    ACTIONS     ------------------ */

export const lockAccount = createAction<LockTypeStrings>(LOCK_ACCOUNT);

export const unlockAccount = createAction(UNLOCK_ACCOUNT);

export const getAccountCapabilities = createAsyncThunk(
  "account/getAccountCapabilities",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchAccountCapabilities();

      const activeConstellation = first(data.me.activeConstellations);
      const activeInsuranceMembership = activeConstellation?.activeInsuranceMembership;

      return activeInsuranceMembership?.capabilities;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

export const getUnderwritingAvailability = createAsyncThunk(
  "account/getUnderwritingAvailability",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchUnderwritingAvailability();
      const underwritingAvailability = {
        coverageAdjustmentAvailable: !!data.me.coverageAdjustmentAvailable,
        reinstatementAvailable: !!data.me.reinstatementAvailable,
      };

      return { underwritingAvailability };
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

export const getEligibleForCoverageUnderwriting = createAsyncThunk(
  "account/getEligibleForCoverageUnderwriting",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchEligibleForUnderwriting();
      const activeAccount = getActiveAccount(response.data.me);

      const eligibleForCoverage = activeAccount?.eligibleForCoverage;
      const eligibleForUnderwriting = activeAccount?.eligibleForUnderwriting;
      const hasPolicy = !!activeAccount?.activePolicy?.id;

      return { eligibleForCoverage, eligibleForUnderwriting, hasPolicy };
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
